import type { PdfSplitJobsState } from "features/pdfSplitJobsSlice";

export const PDF_SPLIT_JOBS_STORAGE_KEY = "calibrate_pdf_split_jobs_v1";

type Persisted = {
  v: 1;
  userId: number;
  jobs: PdfSplitJobsState["jobs"];
};

export function persistPdfSplitJobsState(
  userId: number | undefined,
  jobs: PdfSplitJobsState["jobs"],
): void {
  if (userId == null) return;
  try {
    const payload: Persisted = { v: 1, userId: Number(userId), jobs };
    localStorage.setItem(PDF_SPLIT_JOBS_STORAGE_KEY, JSON.stringify(payload));
  } catch {
  }
}

export function loadPdfSplitJobsState(): Omit<Persisted, "v"> | null {
  try {
    const raw = localStorage.getItem(PDF_SPLIT_JOBS_STORAGE_KEY);
    if (!raw) return null;
    const parsed = JSON.parse(raw) as Persisted;
    if (parsed?.v !== 1 || parsed.userId == null) return null;
    return { userId: Number(parsed.userId), jobs: sanitizeTrackedJobs(parsed.jobs) };
  } catch {
    return null;
  }
}

function idOrNull(value: unknown): number | null {
  const number = Number(value);
  return value == null || !Number.isFinite(number) ? null : number;
}

/** Entries as an older build or a hand-edited store may have left them. */
export function sanitizeTrackedJobs(raw: unknown): PdfSplitJobsState["jobs"] {
  if (!raw || typeof raw !== "object") return {};
  const jobs: PdfSplitJobsState["jobs"] = {};
  for (const [jobId, entry] of Object.entries(raw as Record<string, unknown>)) {
    if (!entry || typeof entry !== "object") continue;
    const item = entry as Record<string, unknown>;
    jobs[jobId] = {
      label: typeof item.label === "string" ? item.label : "Split job",
      userId: idOrNull(item.userId),
      majorJobId: idOrNull(item.majorJobId),
    };
  }
  return jobs;
}

export function clearPdfSplitJobsStorage(): void {
  try {
    localStorage.removeItem(PDF_SPLIT_JOBS_STORAGE_KEY);
  } catch {
  }
}
